import { api } from "@services/api";
import type {
  CreateDisputePayload,
  DisputeDetails,
  DisputeFilterRequest,
  DisputesResponse,
  EligibleAssociatedMovement,
  ResolveDisputePayload,
  UpdateDisputePayload,
} from "@services/disputes/types";

export const getEligibleAssociatedMovements = async ({
  service,
  vesselCallId,
}: {
  service: string;
  vesselCallId: string;
}) =>
  api.get<EligibleAssociatedMovement[]>(
    service,
    `disputes/eligible-associated-movements?vesselCallId=${encodeURIComponent(vesselCallId)}`,
  );

export const getDisputes = async ({
  service,
  payload,
  page = 0,
  pageSize = 25,
}: {
  service: string;
  payload: DisputeFilterRequest;
  page?: number;
  pageSize?: number;
}) => {
  return api.post<DisputesResponse>(
    service,
    `disputes:search?pageSize=${pageSize}&pageNumber=${page}`,
    payload,
  );
};

export const getDisputeById = async (service: string, disputeId: string) => {
  return api.get<DisputeDetails>(service, `disputes/${disputeId}`);
};

export const createDispute = async ({
  service,
  payload,
  transactionId,
}: {
  service: string;
  payload: CreateDisputePayload;
  transactionId?: string;
}) => {
  return api.post<CreateDisputePayload>(
    service,
    "disputes",
    payload,
    ...(transactionId ? [{ transactionId }] : []),
  );
};

export const updateDispute = async ({
  service,
  disputeId,
  payload,
  transactionId,
}: {
  service: string;
  disputeId: string;
  payload: UpdateDisputePayload;
  transactionId?: string;
}) => {
  return api.put<DisputeDetails>(
    service,
    `disputes/${disputeId}`,
    payload,
    ...(transactionId ? [{ transactionId }] : []),
  );
};

export const resolveDispute = async ({
  service,
  disputeId,
  payload,
  transactionId,
}: {
  service: string;
  disputeId: string;
  payload: ResolveDisputePayload;
  transactionId?: string;
}) => {
  return api.put<ResolveDisputePayload>(
    service,
    `disputes/${disputeId}`,
    payload,
    ...(transactionId ? [{ transactionId }] : []),
  );
};
